export const setCookie = (cname, cvalue, extime = "365 d") => {
    var d = new Date();
    d.setTime(d.getTime() + strToExpires(extime));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const strToExpires = (extime) => {
    const split = extime.split(" ");
    const num = split[0];
    const unit = split[1];
    switch (unit) {
        case "s":
            return num * 1000;
        case "m":
            return num * 1000 * 60;
        case "h":
            return num * 1000 * 60 * 60;
        default:
            return num * 1000 * 60 * 60 * 24;
    }
};
